import { Avatar, Button, Modal } from "antd";

import React, { useState } from "react";

const HighLightItem = (props: any) => {
  const { key, highlight } = props;
  const [visible, setVisible] = useState(false);
  const html = highlight.content
    .replaceAll("width: 298.75px;", " ")
    .replaceAll("width: 313.75px;", " ")
    .replaceAll("width: 526.25px;", " ")
    .replaceAll("width: 423.75px;", " ")
    .replaceAll(`nowrap="nowrap"`, " ");

  return (
    <>
      <a
        key={key}
        className="main-content kd-highlight-item-wrapper"
        onClick={() => {
          setVisible(true);
        }}>
        <Avatar src={highlight.img.path}></Avatar>
        <span style={{ padding: "0px 5px" }}>{highlight.name}</span>
      </a>
      {visible && (
        <Modal
          // centered
          visible={visible}
          closable
          maskClosable
          onCancel={() => setVisible(false)}
          width={1000}
          footer={[
            <Button key="back" onClick={() => setVisible(false)}>
              Đóng
            </Button>,
          ]}>
          <div
            dangerouslySetInnerHTML={{
              __html: html,
            }}></div>
        </Modal>
      )}
    </>
  );
};

export default HighLightItem;
